import GOTUtil from './GOTUtil';
import FormItemDateRenderForAutoLookup from '../formItem/renders/FormItemDateRenderForAutoLookup';
import FormItemDateTimeRenderForAutoLookup from '../formItem/renders/FormItemDateTimeRenderForAutoLookup';
import FormItemTimeRenderForAutoLookup from '../formItem/renders/FormItemTimeRenderForAutoLookup';
import FormItemLongRenderForAutoLookup from '../formItem/renders/FormItemLongRenderForAutoLookup';
import FormItemDecimalRenderForAutoLookup from '../formItem/renders/FormItemDecimalRenderForAutoLookup';
import FormItemEnumRenderForAutoLookup from '../formItem/renders/FormItemEnumRenderForAutoLookup';
import FormItemBooleanRenderForAutoLookup from '../formItem/renders/FormItemBooleanRenderForAutoLookup';
import FormItemStringRenderForAutoLookup from '../formItem/renders/FormItemStringRenderForAutoLookup';
const React = require('react');

export default class FormLookupRenderFactory
{
	static getLookupRender(type,dataField,entityId,innerId)
	{
		var entity = GOTUtil.getEntityXML(entityId);
		let item;
		if(type == "Date")
		{
			item = GOTUtil.getItemXML(entityId,innerId);
			/*let numOfDay = GOTUtil.getFinalValue(item,entity,"NumOfDay");
			let numOfMonth = GOTUtil.getFinalValue(item,entity,"NumOfMonth");
			let show1970 = true;//GOTUtil.getFinalValue(item,entity,"Show1970");
			let numOfYear = GOTUtil.getFinalValue(item,entity,"NumOfYear");*/
			let seperator = GOTUtil.getFinalValue(item,entity,"Seperator");

			/*if(!numOfDay)numOfDay = 2;
			if(!numOfMonth)numOfMonth = 2;
			if(!numOfYear)numOfYear = 4;*/
			

			return <FormItemDateRenderForAutoLookup dataField = {dataField} numOfDay={2} numOfMonth={2} show1970={true}
						numOfYear={4} seperator={seperator}/>;
		}
		else if(type == "Time")
		{
			item = GOTUtil.getItemXML(entityId,innerId);
			/*let showHour = GOTUtil.getFinalValue(item,entity,"ShowHour");
			let showMinute = GOTUtil.getFinalValue(item,entity,"ShowMinute");
			let showSecond = GOTUtil.getFinalValue(item,entity,"ShowSecond");*/
			return <FormItemTimeRenderForAutoLookup dataField = {dataField} showHour={true} showMinute={true} showSecond={true}/>;
		}
		else if(type == "DateTime")
		{
			return <FormItemDateTimeRenderForAutoLookup dataField = {dataField}/>;
		}
		else if(type == "Long")
		{
			item = GOTUtil.getItemXML(entityId,innerId);
			let showZero = GOTUtil.getFinalValue(item,entity,"ShowZero");
			let thousandSeperator = GOTUtil.getFinalValue(item,"ThousandSeperator");
			return <FormItemLongRenderForAutoLookup dataField = {dataField} showZero={showZero} thousandSeperator={thousandSeperator}/>;
		}
		else if(type == "Decimal")
		{
			item = GOTUtil.getItemXML(entityId,innerId);
			let showZero = GOTUtil.getFinalValue(item,entity,"ShowZero");
			let showDecimals = GOTUtil.getFinalValue(item,entity,"ShowDecimals");
			if(typeof(showDecimals) == "string" && !showDecimals)
				showDecimals = 2;
			let thousandSeperator = GOTUtil.getFinalValue(item,entity,"ThousandSeperator");
			return <FormItemDecimalRenderForAutoLookup dataField = {dataField} showZero={showZero} showDecimals={showDecimals} thousandSeperator={thousandSeperator}/>;
		}
		else if(type == "String")
		{
			return <FormItemStringRenderForAutoLookup dataField = {dataField}/>;
		}
		else if(type == "Boolean")
		{
			return <FormItemBooleanRenderForAutoLookup dataField = {dataField}/>;
		}
		else if(type == "Enum")
		{
			item = GOTUtil.getItemXML(entityId,innerId);
			let dataProvider = GOTUtil.getDataSourceByTableField(item);//GOTUtil.getFinalValue(item,entity,"DataProvider");

			return <FormItemEnumRenderForAutoLookup  options={dataProvider} dataField = {dataField}/>;
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/FormLookupRenderFactory.js